import packageJson from '../../package.json';

const version = packageJson.version;

const getCsrfTokenFromCookie = () => {
    if (typeof document === 'undefined' || !document.cookie) {
        return null;
    }

    const cookie = document.cookie
        .split('; ')
        .find((entry) => entry.startsWith('csrfToken='));

    if (!cookie) {
        return null;
    }

    const [, value] = cookie.split('=');
    return value || null;
};

const isUnsafeMethod = (method) => {
    return ['POST', 'PUT', 'PATCH', 'DELETE'].includes((method || 'GET').toUpperCase());
};

/**
 * Central fetch wrapper that always sends cookies and the version header.
 * Automatically sets Content-Type: application/json unless the body is FormData.
 */
export async function apiFetch(url, options = {}) {
    const isFormData = options.body instanceof FormData;
    const method = (options.method || 'GET').toUpperCase();
    const csrfToken = isUnsafeMethod(method) ? getCsrfTokenFromCookie() : null;
    const headers = {
        'x-client-version': version,
        ...(csrfToken ? { 'x-csrf-token': csrfToken } : {}),
        ...(!isFormData && { 'Content-Type': 'application/json' }),
        ...(options.headers || {}),
    };
    return fetch(url, { ...options, method, headers, credentials: 'include' });
}
